import React, { Fragment , useState } from 'react';
import ReactDOM from 'react-dom';
import Camera from './Camera';
import {SupportFile } from "../appointments/create/store";
import {  UploadDocuments } from "../appointments/create/api";
import { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  makeStyles
} from "@material-ui/core";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { Theme, createStyles, WithStyles } from "@material-ui/core/styles";
import { withStyles } from '@material-ui/core';

//Update log
// FB 6025 BR   04/26/2022    PE - Import Photos through QR code scan from smartphone

export default function Capturephotos(props:any) {

    const [inputList, setInputList] = useState<SupportFile[]>([]);
    const [base64Img,setBase64Img] =  useState("");
    const [capturedImage,setCapturedImage] =  useState("");
    const [openDialog, setOpenDialog] = React.useState(false);
    const useStyles = makeStyles({
      active: {
        backgroundColor: "#18a2b8",
        color: "white",
        textTransform: "capitalize",
        borderRadius: "15px",
        marginLeft: "20px",
        "&:hover": {
          backgroundColor: "#18a2b8",
        },
      }
    })

    const classes = useStyles();

    const handleClose = async () => {
      setOpenDialog(false);
    };

    const styless = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

    const DialogActions = withStyles((theme: Theme) => ({
      root: {
        margin: 0,
        padding: theme.spacing(1),
      },
    }))(MuiDialogActions);

    useEffect(  () => {
      async function upload () {
        if(base64Img != ""){
          var decodedAppt_n = Buffer.from(props.match.params.apptId, "base64").toString();
          //var encodedDocType = Buffer.from(props.match.params.docType).toString('base64');
          var decodedDocType = Buffer.from(props.match.params.docType , "base64").toString();
            const input = {
                DocumentType: decodedDocType,
                OtherDocument: '',
                FileName: Number(decodedAppt_n) +'.png',
                FileType: 'image/png',
                FileSize: 0,
                Base64EncodedFile: base64Img, 
                Appointment_N: Number(decodedAppt_n)
              } as SupportFile;
            //setInputList([...inputList, input]);
            inputList.push(input);
          const result = await UploadDocuments(inputList, Number(decodedAppt_n));
        if (result === 200) {
          //alert("File uploaded successfully!");
          setOpenDialog(true);
          setCapturedImage("saved");
          setInputList([]);
        }
        }
      }
   upload();
    }, [base64Img]);

    const uploadImage = async (file:any) => {
      const formData = new FormData();
      formData.append("file", file);
    
      // Connect to a seaweedfs instance
    };


    return (
        <div className="App">
            <p>Capture image from your camera!!</p>
            <Camera sendFile={uploadImage}  callBack={setBase64Img} />

            <Dialog
            onClose={handleClose}
            maxWidth={"xs"}
            id="validationDialog"
            aria-labelledby="customized-dialog-title"
            open={openDialog}
          >
          
            <DialogContent dividers>
              <Typography style={{ fontSize: "14px" }} gutterBottom>
              File uploaded successfully!
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                className={classes.active}
                onClick={handleClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
    );
}
